document.addEventListener('DOMContentLoaded', function() {
  // Get product name from URL
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  const productNameFromUrl = getUrlParameter('product_name');
  console.log('Product name from URL:', productNameFromUrl);

  if (!productNameFromUrl) return;

  const decodedProductName = productNameFromUrl;
  let fieldFound = false;

  // Function to properly set value with all required events
  function setFieldValue(field, value) {
   // console.log('Setting field value properly...');
    
    // Focus the field first (some frameworks need this)
    field.focus();
    
    // Set the value property (for React/JavaScript frameworks)
    field.value = value;
    
    // Also set the attribute (for some validation libraries)
    field.setAttribute('value', value);
    
    // Trigger all the events that the framework might be listening to
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    field.dispatchEvent(new Event('blur', { bubbles: true }));
    
    // For React specifically
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, 
      'value'
    ).set;
    
    if (nativeInputValueSetter) {
      nativeInputValueSetter.call(field, value);
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
    
    // Make it read-only
    field.readOnly = true;
    console.log('✓ Field value properly set:', field.value);
  }

  // Search through shadow DOM
  function searchInShadowDOM(root = document, depth = 0) {
    // Check all inputs in current context
    const inputs = root.querySelectorAll('input');
    inputs.forEach(input => {
      // Look for first name field by various identifiers
      if (
        input.id === 'custom#product_title' ||
        input.getAttribute('data-testid')?.includes('field-custom#product_title')
      ) {
        console.log(`✓ Found field at depth ${depth}:`, {
          id: input.id,
          name: input.name,
          type: input.type
        });
        setFieldValue(input, decodedProductName);
        fieldFound = true;
      }
    });

    // If found, stop searching
    if (fieldFound) return true;

    // Search in shadow roots
    root.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot && !fieldFound) {
        console.log(`Entering shadow DOM of ${element.tagName}, depth: ${depth + 1}`);
        searchInShadowDOM(element.shadowRoot, depth + 1);
      }
    });

    return fieldFound;
  }

  // Main function to wait and search
  function initializeFormFill() {
    //console.log('Starting form fill process...');
    
    // Try immediately
    if (searchInShadowDOM()) {
      //console.log('✓ Field filled on first attempt');
      return;
    }

    // Set up observer for dynamic content
    const observer = new MutationObserver(function() {
      //console.log('DOM changed, searching for field...');
      if (!fieldFound) {
        searchInShadowDOM();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Special handling for Shopify Forms component
    const formComponent = document.querySelector('shopify-forms-embed');
    if (formComponent) {
     // console.log('Found Shopify Forms component, adding special listener');
      
      // Try multiple times as the component loads
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
       // console.log(`Attempt ${attempts} to find field...`);
        
        if (searchInShadowDOM() || attempts > 20) {
          clearInterval(interval);
          observer.disconnect();
          if (attempts > 20) {
            console.log('Max attempts reached');
            tryAlternativeMethods();
          }
        }
      }, 500);
    }

    // Fallback after 10 seconds
    setTimeout(() => {
      observer.disconnect();
      if (!fieldFound) {
       // console.log('Trying fallback methods...');
        tryAlternativeMethods();
      }
    }, 10000);
  }

  // Alternative methods if direct manipulation doesn't work
  function tryAlternativeMethods() {
   // console.log('Trying alternative methods...');
    
    // Method 1: Try to use the app's own JavaScript API
    if (window.ShopifyForms && typeof window.ShopifyForms.setFieldValue === 'function') {
     // console.log('Using Shopify Forms API');
      window.ShopifyForms.setFieldValue('field-custom#product_title', decodedProductName);
    }
    
    // Method 2: Dispatch a custom event the app might listen to
    const prefillEvent = new CustomEvent('shopify-forms:prefill', {
      detail: {
        fields: {
          product_title: decodedProductName
        }
      }
    });
    document.dispatchEvent(prefillEvent);
    //console.log('Dispatched prefill event');
    
    // Method 3: Try URL hash method
    window.location.hash = `#product_title=${encodeURIComponent(decodedProductName)}`;
    
    // Method 4: Create a hidden form and use it
    const hiddenForm = document.createElement('form');
    hiddenForm.style.display = 'none';
    hiddenForm.innerHTML = `<input name="product_title" value="${decodedProductName}">`;
    document.body.appendChild(hiddenForm);
   // console.log('Created hidden form with value');
  }

  // Start the process after a short delay
  setTimeout(initializeFormFill, 100);
});

const link = document.querySelector('a[href="#product-description"]');
if (link) {
  link.addEventListener("click", function(e) {
  e.preventDefault();

  const section = document.getElementById("product-description");
  window.scrollTo({
    top: section.offsetTop - 140,
    behavior: "smooth"
  });
});
}

// Thank You page
document.addEventListener("DOMContentLoaded", function () {

  if(window.location.href.indexOf('contact_posted=true') > -1){
      window.location.href = '/pages/thank-you';
  }

});


document.addEventListener("DOMContentLoaded", function () {

  // Header phone number
  const headerPhones = document.querySelectorAll('.header-contact a');

  headerPhones.forEach(function(item){
    item.classList.add('header-phone-number');
  });

  // Footer phone number
  const footerPhones = document.querySelectorAll('.footer-block__details-content a[href^="tel:"]');

  footerPhones.forEach(function(item){
    item.classList.add('Footer-phone-number');
  });

});



